import React, { Component } from 'react';
import t from 'prop-types';

import OLTileLayer from 'ol/layer/tile';

class TileLayer extends Component {
  constructor(props) {
    super(props);

    this.tileLayer = new OLTileLayer({
      opacity: props.opacity
    });
    props.mapInstance.addLayer(this.tileLayer);
  }

  componentWillUnmount() {
    this.props.mapInstance.removeLayer(this.tileLayer);
  }

  componentDidUpdate(prevProps) {
    if(prevProps.opacity != this.props.opacity) {
      this.tileLayer.setOpacity(this.props.opacity);
    }
  }

  render() {
    return React.cloneElement(this.props.children, { tileLayer: this.tileLayer })
  }
}

TileLayer.propTypes = {
  opacity: t.number
}

export default TileLayer;



// WEBPACK FOOTER //
// ./src/components/ol/TileLayer.js